import { styled } from "styled-components";
import { Product } from "@ludens-reklame/rubics-v3-sdk/product/types";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { Ruler } from "./Ruler.js";
import { ProductLabelImage } from "./ProductLabel.js";

interface Props {
  product: Product;
  titleElement?: string;
}

export const ProductCard: React.FC<Props> = ({ product, titleElement }) => {
  return (
    <Card href={product.url}>
      {product.labels.map((label) => {
        if (label.image) {
          return (
            <ProductLabelImage
              src={transformImageUrl(label.image, {
                width: 200,
                height: 200,
                fit: "contain",
              })}
              alt={label.image.altText}
            />
          );
        }

        return null;
      })}
      {product.primaryImage && (
        <ProductImage
          src={transformImageUrl(product.primaryImage, {
            width: 418,
            height: 354,
            fit: "contain",
          })}
          alt={product.primaryImage.altText}
        />
      )}
      <Text>
        <Title as={titleElement}>{product.name}</Title>
        <Ruler $maxWidth="140px" $centered />
        <Price $hasCompare={!!product.compareAtPrice}>
          {!!product.compareAtPrice && (
            <span className="compare">{product.compareAtPriceText}</span>
          )}
          <span>{product.priceText}</span>
        </Price>
      </Text>
    </Card>
  );
};

const Card = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  color: var(--swatch2);
  padding: ${(props) => props.theme.spacing.m};
  border-radius: 10px;
  text-align: center;
  text-decoration: none;
  transition: box-shadow 0.2s ease-in-out;

  &:focus,
  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25);
  }
`;

const ProductImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: ${(props) => props.theme.spacing.s};
  aspect-ratio: 1.1807909605;
`;

const Text = styled.div`
  margin-top: auto;
  width: 100%;
`;

const Title = styled.p.attrs({ className: "h4" })`
  margin: 0;
`;

const Price = styled.p.attrs({ className: "h5" })<{ $hasCompare?: boolean }>`
  margin: 0;
  display: flex;
  justify-content: ${(props) =>
    props.$hasCompare ? "space-between" : "center"};
  gap: ${(props) => props.theme.spacing.m};

  .compare {
    font-weight: 400;
    text-decoration: line-through;
  }
`;
